import TablePaginationMui from '@mui/material/TablePagination'
import { Typography, Pagination } from '@mui/material'
import { useRouteQuery } from '@/hooks'

export interface TablePaginationProps {
  total: number
  perPage: number
  page: number
  toggleShow?: boolean
  onPageChange?: (page: number) => void
}

const TablePaginationComponent = ({
  meta,
  toggleShow = true,
  onPageChange
}: {
  meta: TablePaginationProps
  toggleShow?: boolean
  onPageChange?: (page: number) => void
}) => {
  const { __ } = useTranslator()
  const { updateQuery } = useRouteQuery()

  const handlePageChange = (_: any, page: number) => {
    if (onPageChange) {
      onPageChange(page)
    } else {
      updateQuery({ page })
    }
  }

  return (
    <div
      className={`flex ${toggleShow ? 'justify-between bs-auto' : 'justify-center'} items-center flex-wrap pli-6  plb-[12.5px] gap-2`}
    >
      {toggleShow && (
        <Typography color='text.disabled'>
          {`${__('Showing')} ${meta?.total === 0 ? 0 : (meta?.page - 1) * meta?.perPage + 1}
        ${__('to')} ${Math.min(meta?.page * Number(meta?.perPage), meta?.total)} of ${meta?.total} entries`}
        </Typography>
      )}
      <Pagination
        color='primary'
        variant='tonal'
        count={Math.ceil(meta?.total / meta?.perPage)}
        page={meta?.page}
        onChange={handlePageChange}
        showFirstButton
        showLastButton
      />
    </div>
  )
}

export function TablePagination({
  meta,
  toggleShow = true,
  onPageChange
}: {
  meta: TablePaginationProps
  toggleShow?: boolean
  onPageChange?: (page: number) => void
}) {
  return (
    <TablePaginationMui
      component={() => <TablePaginationComponent meta={meta} toggleShow={toggleShow} onPageChange={onPageChange} />}
      count={meta?.total || 0}
      rowsPerPage={meta?.perPage || 10}
      page={meta?.page}
      onPageChange={() => {}}
    />
  )
}
